const blogs = [
    {
        title: '06/23/25',
        fileName: 'week0.md'
    },
    {
        title: '06/30/25',
        fileName: 'week1.md'
    },
    {
        title: '07/07/25',
        fileName:'week2.md'
    },
    {
        title: '07/14/25',
        fileName:'week3.md'
    },
    {
        title: '07/21/25',
        fileName: 'week4.md'
    },
    {
        title: '07/28/25',
        fileName: 'week5.md',
        id: 'week5-blog'
    },
    {
        title: '08/04/25',
        fileName: 'week6.md',
        id: 'week6-blog'
    },
    {
        title: '08/11/25',
        fileName: 'week7.md',
        id: 'week7-blog'
    },
    {
        title: '08/18/25',
        fileName: 'week8.md',
        id: 'week8-blog'
    },
    {
        title: '08/25/25',
        fileName: 'week9.md',
        id: 'week9-blog'
    },
    {
        title: '09/01/25',
        fileName: 'week10.md',
        id: 'week10-blog'
    },
    {
        title: '09/08/25',
        fileName: 'week11.md',
        id: 'week11-blog'
    },
    {
        title: '09/15/25',
        fileName: 'week12.md',
        id: 'week12-blog'
    },
    {
        title: '09/22/25',
        fileName: 'week13.md',
        id: 'week13-blog'
    },
    {
        title: '09/29/25',
        fileName: 'week14.md',
        id: 'week14-blog'
    },
    {
        title: '10/06/25',
        fileName: 'week15.md',
        id: 'week15-blog'
    },
    {
        title: '10/13/25',
        fileName: 'week16.md',
        id: 'week16-blog'
    },
    {
        title: '10/20/25',
        fileName: 'week17.md',
        id: 'week17-blog'
    },
    {
        title: '10/27/25',
        fileName: 'week18.md',
        id: 'week18-blog'
    },
    {
        title: '11/03/25',
        fileName: 'week19.md',
        id: 'week19-blog'
    },
    {
        title: '11/10/25',
        fileName: 'week20.md',
        id: 'week20-blog'
    },
    {
        title: '11/17/25',
        fileName: 'week21.md',
        id: 'week21-blog'
    },
    {
        title: '11/24/25',
        fileName: 'week22.md',
        id: 'week22-blog'
    },
    {
        title: '12/01/25',
        fileName: 'week23.md',
        id: 'week23-blog'
    },
    {
        title: '12/08/25',
        fileName: 'week24.md',
        id: 'week24-blog'
    },
    {
        title: '12/15/25',
        fileName: 'week25.md',
        id: 'week25-blog'
    }
];

export default blogs;